import React from "react";
import {
  TopToolbar,
  RefreshButton,
  Toolbar,
  SaveButton,
  ListButton,
  ShowButton,
  Edit,
  SimpleForm,
  ArrayInput,
  TextField,
  TextInput,
  useRecordContext,
  NumberInput,
  ReferenceField,
} from "react-admin";
import { monthList } from "../common/common";
import Card from "@mui/material/Card";
import { withStyles } from "@mui/styles";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const EditActions = ({ permissions, basePath, data, resource }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const EditTitle = () => {
  return <span>Edit Target</span>;
};

const editStyles = {
  root: { display: "flex", alignItems: "flex-start", width: "100%" },
  form: { flexGrow: 9 },
};

const FormDiv = withStyles(editStyles)(
  ({ children, classes, basePath, ...props }) => {
    // console.log("Umesh Jadhav", props, children, basePath);
    const record = useRecordContext();
    console.log("Umesh Jadhav", record);
    return (
      <div className={classes.root}>
        <div className={classes.form}>
          <div className="target-edit-element-group target-edit-element-group-padding-bottom">
            <div className="target-edit-element">
              <label class="month" for="sold_to_code">
                <span>Sold To Code</span>
              </label>
              <div>
                <span id="month">{record.sold_to_code}</span>
              </div>
            </div>
            <div className="target-edit-element">
              <label class="month" for="name">
                <span>Sold To Name</span>
              </label>
              <div>
                <span id="month">{record.sold_to_name}</span>
              </div>
            </div>
          </div>
          <div className="target-edit-element-group">
            <div className="target-edit-element">
              <label class="month" for="month">
                <span>Month</span>
              </label>
              <div>
                <span id="month">{monthList[Number(record.month) - 1]}</span>
              </div>
            </div>
            <div className="target-edit-element">
              <label class="month" for="year">
                <span>Year</span>
              </label>
              <div>
                <span id="month">{record.year}</span>
              </div>
            </div>
          </div>
          <div className="target-edit-element-group">
            <span className="target-edit-element">
              <NumberInput
                source="target_0"
                defaultValue={
                  record.target_data[0] ? record.target_data[0].target : 0
                }
                label="Target 1"
              />
            </span>
            <span className="target-edit-element">
              <NumberInput
                source="rebate_0"
                defaultValue={
                  record.target_data[0] ? record.target_data[0].rebate : 0
                }
                label="Rebate 1"
              />
            </span>
          </div>
          <div className="target-edit-element-group">
            <span className="target-edit-element">
              <NumberInput
                source="target_1"
                defaultValue={
                  record.target_data[1] ? record.target_data[1].target : 0
                }
                label="Target 2"
              />
            </span>
            <span className="target-edit-element">
              <NumberInput
                source="rebate_1"
                defaultValue={
                  record.target_data[1] ? record.target_data[1].rebate : 0
                }
                label="Rebate 2"
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
);

const BusinessTargetEdit = ({ permissions, ...props }) => {
  const noOftargets = [...Array(3).keys()];
  console.log("props", props);
  return (
    <Edit
      actions={<EditActions permissions={permissions} />}
      {...props}
      title={<EditTitle />}
      undoable={false}
    >
      <SimpleForm toolbar={<EditToolbar />}>
        <FormDiv record={props.record} />
      </SimpleForm>
    </Edit>
  );
};

export default BusinessTargetEdit;
